import { render, staticRenderFns } from "./DetalleRecargosTarifas.vue?vue&type=template&id=4391516a&scoped=true"
import script from "./DetalleRecargosTarifas.vue?vue&type=script&lang=js"
export * from "./DetalleRecargosTarifas.vue?vue&type=script&lang=js"
import style0 from "./DetalleRecargosTarifas.vue?vue&type=style&index=0&id=4391516a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4391516a",
  null
  
)

export default component.exports